import 'react';
import 'react-dom';
import 'react-relay';
import 'relay-runtime';
import 'redux';
import 'react-redux';
import 'react-intl';
import 'url-search-params-polyfill';
import 'intersection-observer';
import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();
